
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { AvatarProps } from 'antd/es/avatar'
import { useAppSelector } from '../../store/hooks'
import { Segment as SegmentModel } from '../../models/Segment'
import { Avatar, Space, Tooltip, Typography } from 'antd'
import { selectSegmentById } from '../../store/SegmentReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'

const { Text } = Typography

type Props = SBModelComponent<SegmentModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

const SegmentAvatar: FC<Props> = ({
  id,
  model,
  size = 'default',
  type = 'full',
}) => {
  const item = model ? model : useAppSelector(selectSegmentById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Link to={`/segments/${item.id}`}>
      <Space direction="horizontal">
        <Tooltip title={item.title} open={type == 'full' ? false : undefined}>
          <Avatar
            shape="square"
            size={size == 'large' ? 60 : size}
            style={{
              color: '#fff',
              backgroundImage: `url(${item.icon})`,
              fontSize: size == 'small' ? 11 : undefined,
            }}
          ></Avatar>
        </Tooltip>
        {type == 'full' && (
          <Space.Compact direction="vertical">
            <Space direction="horizontal">
              <Text>{item.title}</Text>
            </Space>
          </Space.Compact>
        )}
      </Space>
    </Link>
  )
}

type SegmentAvatarType = { Avatar: typeof SegmentAvatar }

export { SegmentAvatar, type SegmentAvatarType }
